import React, { useContext } from 'react';
import Select from '../components/Select';
import i18n from '~/i18n';
import { OrderContext } from '~/App/Layout/providers/OrderProvider';
import { checkIsRequireTableNumber } from '@restaurant/constants';
import { OrderType } from '@restaurant/types';
import { tableOptions } from '~/constants/common';

const SelectTable = () => {
  const { order, setOrder } = useContext(OrderContext);
  const disabled =
    !order.isNew ||
    Boolean(order.orderType && !checkIsRequireTableNumber(order.orderType));

  const onChange = async (value: number) => {
    if (disabled) return;

    setOrder({
      ...order,
      ...(order.orderType == null ? { orderType: OrderType.DineIn } : {}), // auto set to dine-in if table is selected
      tableNumber: value,
    });
  };

  return (
    <Select
      options={tableOptions}
      value={order.tableNumber}
      onChange={onChange}
      placeholder={i18n.t('order_info_choose_table')}
      disabled={disabled}
    />
  );
};

export default SelectTable;
